import { api } from '../../../api';

export const getCountriesAPI = () => {
  return api.get('/v1/countries');
};
